import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Common } from '../domains/common';
import { GeneralInformationResponse } from '../domains/GeneralInformationResponse';

@Injectable()
export class RegistrationService {
  constructor(private http: HttpClient) { }

  private baseUrl = 'https://74.207.233.48:8443/HRCLADM_2018/'; //main "https://74.207.233.48/AdmissionPG2026/"
  // private baseUrl = 'http://45.79.217.254:8080/HRCLADM_2018/';
  // private baseUrl = 'http://45.79.253.141:8080/HRCLADM_2018/';  //demo "http://45.79.253.141/AdmissionPG2024/"
  // private baseUrl = 'https://45.79.253.141:8443/HRCLADM_2018/';
  // private baseUrl = 'http://45.79.205.231:8080/HRCLADM_2018/';  //demo "http://45.79.205.231/AdmissionPG2026/"

  /** GET religionList,categoryList,mothertongueList from the server */

  getCommonList() {
    return this.http.get(this.baseUrl + 'reg-common-api').toPromise().then(res => <Common>res);
  }

  /** POST Login Information to the server */

  studentLogin(data) {
    // console.log(data);
    return this.http
      .post(this.baseUrl + 'student-login', data)
      .toPromise()
      .then(res => <GeneralInformationResponse>res);
  }

  studentLoginotp(data){
    //console.log(data);
    return this.http
      .get(this.baseUrl + 'student-login-otp/?mobno=' + data)
      .toPromise()
      .then(res => <any>res);
  }

  verifyOtpforlogin(mobno,otp){
    return this.http
    .get(this.baseUrl + 'student-login-otp-validate?mobno=' + mobno + '&otp=' + otp)
    .toPromise()
    .then(res => <any>res);
  }

  isAuthenticated() {
    const token = localStorage.getItem('authToken');
    return token ? true : false;
  }

  /** POST General Information to the server */
  registerUser(data) {
    console.log(data)
    return this.http
      .post(this.baseUrl + 'reg-submit', data)
      .toPromise()
      .then(res => <GeneralInformationResponse>res);
  }

  /** GET ** from the server */
  getAcademicList(token) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'academic-common-api', httpOptions)
      .toPromise()
      .then(res => <Common>res);
  }
  getStateCity(c, s, city) {
    return this.http.get(this.baseUrl + 'getStateCity/' + c + '/' + s + '/' + city);
  }

  saveAcademicDetails(token, dt) {
    // console.log(dt);
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.post(this.baseUrl + 'submitAcademicInfo', dt, httpOptions);
  }

  deleteRowByMarksId(id) {
    return this.http.delete(this.baseUrl + 'deleteMarksById/' + id + '');
  }

  loginByToken(token) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.get(this.baseUrl + 'loginby-token', httpOptions);
  }

  getEligibleCourseListApi(token) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.get(this.baseUrl + 'eligible-courses-list', httpOptions);
  }

  saveCourseSelectionApi(token, dt) {
    //console.log(dt);
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.post(this.baseUrl + 'submit-courses', dt, httpOptions);
  }

  getAdditionalList(token) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.get(this.baseUrl + 'additional-common-api', httpOptions);
  }
  saveAdditionalDetailsApi(token, data) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.post(
      this.baseUrl + 'additional-submit',
      data,
      httpOptions
    );
  }
  deleteRowBySports(index) {
    return this.http.delete(this.baseUrl + 'deleteSportById/' + index + '');
  }

  getPaymentDetails(token, challan) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.get(this.baseUrl + 'get-PayAmount-Challan/' + challan + '', httpOptions);
  }
  submitPayement(payType, chln, token) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.get(
      this.baseUrl +
      'updatePaymentDetails?chllno=' +
      chln +
      '&aptype=' +
      payType,
      httpOptions
    );
  }

  getPaymentStatus(id, status) {
    return this.http.get(this.baseUrl + 'getpaymentdetails/' + id + '/' + status);
  }

  /** GET Course Wise Application Status from the server */
  getCourseWiseApplicationStatus(token) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'Course-Wise-Application-Status', httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  checkregNumber(r) {
    return this.http.get(this.baseUrl + 'checkRegNo/' + r + '');
  }

  /** GET Common dat of Dashboard from the server */
  getDashboardCommon(token) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'dashboard-common-api', httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  /** Print form or challan */
  printFormChallan(token, type, challanId) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'duplicate-print?type=' + type + '&challan=' + challanId, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }
  /** get Otp for Forgot password */
  getOTP(data) {
    //console.log(data);
    return this.http
      .get(this.baseUrl + 'forget-pass-otp-generate?moblno=' + data.moblno + '&dob=' + data.dob)
      .toPromise()
      .then((res => <any>res));
  }
  /** get Forgot password */
  getPassword(fid, otp) {
    const httpOptions = {
      headers: new HttpHeaders({ 'F-Id': fid })
    };
    return this.http
      .get(this.baseUrl + 'get-forget-password?otp=' + otp, httpOptions)
      .toPromise()
      .then((res => <any>res));
  }

  getSelectedSubject(token, admStatusId) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'get-selected-subject/' + admStatusId, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  getSubjectForSelection(token,courseId) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'Course-Wise-Subject-Selection-List?courseId=' + courseId, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  saveSubjectSelection(token, data, admStatusId) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
    .post(this.baseUrl + 'Submit-Course-Wise-Subject-Selection/' + admStatusId, data, httpOptions)
    .toPromise()
    .then(res => <any>res);

  }

  getPaperList(token, id) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'get-paper-by-boardid/' + id, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  changePass(data) {
    //console.log(data);
    return this.http
      .post(this.baseUrl + 'change-password', data)
      .toPromise()
      .then(res => <any>res);
  }

  /** Print form or challan */
  getChallanOrForm(token, id, challanno) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'duplicate-print?type=' + id + '&challan=' + challanno, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  updategeneralInfo(token, data) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .post(this.baseUrl + 'update-general-info',data, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  loginForPayment(data) {
    return this.http
      .post(this.baseUrl + 'payment-login',data)
      .toPromise()
      .then(res => <any>res);
  }

  getcoursechallan(challan) {
    return this.http.get(this.baseUrl + 'get-course-challan/' + challan + '');
  }

  /** Print Admit Card */
  getAdmitCard(token, id, courseid) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'get-admit-card?id=' + id + '&courseid=' + courseid, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  getFianancialAid(token,id,coursedetailsid,courseid){
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'get-financial-aid?id=' + id + '&courseid=' + courseid+ '&coursedetailsid=' + coursedetailsid, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  submitFamilyInfo(token, data) {
    // console.log(data);
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.post(
      this.baseUrl + 'family-info-submit',
      data,
      httpOptions
    );
  }

  getAdmissionFess(token,cdid){
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'get-admission-fees?cdid=' + cdid, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  submitAdmissionPayment(token,cdid,payType){
    // console.log(token,cdid,payType);
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.get(
      this.baseUrl +
      'updateAdmissionPayment?cdid=' + cdid + '&aptype=' + payType,httpOptions);
  }

  getPaymentStatusadm(cdid, type) {
    return this.http.get(this.baseUrl + 'getpaymentdetailsadm/' + cdid + '/' + type);
  }

  getadmchallan(token, cdid) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'getadmfeeschallan/' + cdid, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }
  getadmForm(token, cdid) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'getadmform/' + cdid, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  docupload(data, flg,pid) {
		//console.log(data);
		return this.http.post(this.baseUrl + 'doc-upload/' + flg+ '/' + pid, data)
			.toPromise()
			.then(res => res);
  }

  showdoc(pid) {
    return this.http
      .get(this.baseUrl + 'show-document/' + pid)
      .toPromise()
      .then(res => <any>res);
  }

  getdate(token,id) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
		return this.http.get(this.baseUrl + 'get-docverification-date/' + id, httpOptions)
			.toPromise()
			.then(res => res);
  }

  getslot(token,id) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
		return this.http.get(this.baseUrl + 'get-docverification-slot/' + id, httpOptions)
			.toPromise()
			.then(res => res);
  }

  savenewdate(id,slotid,reason) {
    return this.http.get(this.baseUrl + 'get-docverification-slot-save/' + id+ '/' + slotid+ '/' + reason)
      .toPromise()
      .then(res => <any>res);
  }

  clearAccademicDetail() {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': localStorage.getItem('authToken') })
    };
    return this.http
      .get(this.baseUrl + 'clear-academic-detail', httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  submitfinancialaid(data,token) {
    // console.log(data);
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http.post(
      this.baseUrl + 'submit-financial-aid',
      data,
      httpOptions
    );
  }

  getfiancialdetails(token,coursedetailid) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'load-financial-aid?coursedetailid='+coursedetailid, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }
  sendphotosms(token) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'send-student-sms', httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  getsportsdetails(token,coursedetailid) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'load-sports-details?coursedetailid='+coursedetailid, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  submitsportsform(token,coursedetailid){   //update by JD
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'submit-sports-details?coursedetailid='+ coursedetailid, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  getsportsquotaform(token,id,coursedetailsid,courseid){
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'get-sportsquota?id=' + id + '&coursedetailsid=' + coursedetailsid+ '&courseid=' + courseid, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }


  // latest addition for otp 06.07.2021 by a==========================

  getchangepasswordotp(token,oldpassword){
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    // console.log(token,oldpassword);
    return this.http
      .get(this.baseUrl + 'getchangepasswordotp?oldpassword=' + oldpassword, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  // changepassword(token,newpassword){
  //   const httpOptions = {
  //     headers: new HttpHeaders({ 'X-Auth-Token': token })
  //   };
  //   console.log(token,newpassword);
  //   return this.http
  //     .post(this.baseUrl + 'change-password?newpassword='+newpassword, httpOptions)
  //     .toPromise()
  //     .then(res => <any>res);
  // }

  changepasswordbyotp(token,newpassword){
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    // console.log(token,newpassword);
    return this.http
      .get(this.baseUrl + 'changepasswordbyotp?newpassword='+newpassword, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  sendfthmthmobocpdtlsfaidgjrt(token){
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    // console.log(token);
    return this.http
      .get(this.baseUrl + 'sendfthmthmobocpdtlsfaidgjrt', httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  sendeoistatuscoursewisevalidation(token,courseid,crsdtlsid){
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
    .get(this.baseUrl + 'sendeoistatuscoursewisevalidation?courseid='+courseid + '&crsdtlsid=' + crsdtlsid, httpOptions)
    .toPromise()
    .then(res => <any>res);
  }

  updateeoistatuscoursewise(token,courseid,chkeoi,crsdtlsid){
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
    .get(this.baseUrl + 'updateeoistatuscoursewise?courseid='+courseid + '&chkeoi=' + chkeoi + '&crsdtlsid=' + crsdtlsid, httpOptions)
    .toPromise()
    .then(res => <any>res);
  }

  updateDocDetails(token, type, value) {
    const httpOptions = {
      headers: new HttpHeaders({ 'X-Auth-Token': token })
    };
    return this.http
      .get(this.baseUrl + 'update-doc-details?type=' + type + '&value=' + value, httpOptions)
      .toPromise()
      .then(res => <any>res);
  }

  giveOtp(mobno, email) {
    // console.log(mobno,email);
    return this.http
      .get(this.baseUrl + 'verify-mobile-otp?mobno=' + mobno + '&email=' + email)
      .toPromise()
      .then(res => <any>res);
  }

  pushWhatsAppNotification(whatsapp_template, whatsapp_no, name, passWord, phoneNo) {
    const data = {
      countryCode: "+91",
      phoneNumber: whatsapp_no,
      type: "Template",
      template: {
        name: whatsapp_template,
        languageCode: "en",
        headerValues: ["Alert"],
        bodyValues: [name, phoneNo, passWord]
      },
      data: {
        message: ""
      }
    };
    const httpOptions = {
      headers: new HttpHeaders({ "Authorization": "Basic RGY2dkVyZThGQUJ4enhXN2pRSkxJaXEzMlJaN3V3REpDQTRFbWFpMWs1WTo=", "Content-Type": "application/json" })
    };
    return this.http.post('https://api.interakt.ai/v1/public/message/', data, httpOptions).toPromise()
      .then(res => <any>res);

  }

  giveMsgForMob(dltid, mask, mobno, pw, un, sub) {
    console.log(dltid, mask, mobno, pw, un, sub)
    const headers = new HttpHeaders({
      'dltid': dltid,
      'mask': mask,
      'mobno': mobno,
      'pw': pw,
      'un': un,
      'sub': sub
    });

    const options = {
      headers: headers
    };

    return this.http.get<any>('https://172.105.148.188:8443/HRCLParentLS/send-sms', options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error('SMS not sent:', error);
        throw new Error('SMS not sent. Please try again.');
      });
  }

  giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto) {
    const headers = new HttpHeaders({
      'name': name,
      'un': emlun,
      'pw': emlpw,
      'sub': emlsub,
      'body': emlbody,
      'sendto': emlsendto
    });

    const options = {
      headers: headers
    };

    return this.http.get<any>('https://172.105.148.188:8443/HRCLParentLS/generic-send-mail', options)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error('SMS not sent:', error);
        throw new Error('SMS not sent. Please try again.');
      });
  }

  
  payPaynimo(challan: string, token: string) {
    var url = this.baseUrl +
      'setonlinepaymentpaynimo/' +
      challan + '/' + token;
    window.open(url, '_self');
  }

  payPaynimoAdm(cdid: string, token: string) {
    var url = this.baseUrl +
      'setonlinepaymentpaynimoadm/' +
      cdid + '/' + token;
    window.open(url, '_self');
  }


}



// WEBPACK FOOTER //
// ./src/app/services/registration.service.ts